import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { DatePicker } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import util from '@utils/util';

import './TimeEleCustomComponent.less';

function format2Date(date) {
  const pad = n => n < 10 ? `0${n}` : n;
  const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return `${dateStr}`;
}
function format2Time(date) {
  const pad = n => n < 10 ? `0${n}` : n;
  const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  return `${timeStr}`;
}
export default function TimeEleCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  if (customFeature.ifAllDay) {
    styleObj['width'] = '100%';
  }

  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  const Btn = ({ extra, onClick, children }) => (
    <div className="time-btn" onClick={onClick}>{children}{extra}</div>
  );
  /**
   * 绑定事件
   */
  function bindDateChange(v) {
    let value        = format2Date(v);
    let pageInstance = app.getAppCurrentPage();
    let datakey      = `eles[${formCompindex}].form_data.${customFeature.segment}`;
    let compindex    = props.index;
    let formcompindex = formCompindex;
    let segment      = customFeature.segment;
    let newdata      = {};

    if (!segment) {
      app.showModal({
        content: '该组件【时间】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }

    let obj = pageInstance.data.eles[formcompindex]['form_data'];
    if (util.isPlainObject(obj)) {
      obj = pageInstance.data.eles[formcompindex]['form_data'] = {};
    }
    obj = obj[segment];

    if (!!obj) {
      let date = obj.substr(0, 10);
      let time = obj.substr(11);

      if (obj.length == 16) {
        newdata[datakey] = value + ' ' + time;
      } else if (obj.length == 10) {
        newdata[datakey] = value;
      } else if (obj.length == 5) {
        newdata[datakey] = value + ' ' + obj;
      } else if (obj.length == 0) {
        newdata[datakey] = value;
      }
    } else {
      newdata[datakey] = value;
    }
    newdata['eles[' + formcompindex +'].content[' + compindex + '].date'] = value;
    pageInstance.setData(newdata);
  }
  function bindTimeChange(v) {
    let value        = format2Time(v);
    let pageInstance = app.getAppCurrentPage();
    let datakey      = `eles[${formCompindex}].form_data.${customFeature.segment}`;
    let compindex    = props.index;
    let formcompindex = formCompindex;
    let segment      = customFeature.segment;
    let newdata      = {};

    if (!segment) {
      app.showModal({
        content: '该组件【时间】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }

    let obj = pageInstance.data.eles[formcompindex]['form_data'];
    if (util.isPlainObject(obj)) {
      obj = pageInstance.data.eles[formcompindex]['form_data'] = {};
    }
    obj = obj[segment];

    if (!!obj) {
      let date = obj.substr(0, 10);
      let time = obj.substr(11);

      if (obj.length == 16) {
        newdata[datakey] = date + ' ' + value;
      } else if (obj.length == 10) {
        newdata[datakey] = obj + ' ' + value;
      } else if (obj.length == 5) {
        newdata[datakey] = value;
      } else if (obj.length == 0) {
        newdata[datakey] = value;
      }
    } else {
      newdata[datakey] = value;
    }
    newdata['eles[' + formcompindex +'].content[' + compindex + '].time'] = value;
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */ 
  return (
    <div className="custom-component time-ele" style={styleObj}>
      <DatePicker mode="date" format="YYYY-MM-DD" extra={data.date || '请选择日期'} onChange={(v)=> bindDateChange(v)}>
        <Btn></Btn>
      </DatePicker>
      <DatePicker mode="time" format="HH:mm" extra={data.time || '请选择时间'} onChange={(v)=> bindTimeChange(v)}>
        <Btn></Btn>
      </DatePicker>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/time-ele-custom-component/TimeEleCustomComponent.jsx